import { buildDocumentsTree } from '@cd3p/core/utils/documents';
import { State } from 'modules';

export const releaseNotes = (state: State) => state.releaseNotes;
export const releaseNotesItems = (state: State) => state.releaseNotes.items;
export const releaseNotesItemsLoading = (state: State) =>
  state.releaseNotes.loadReleaseNotesDocumentsPending;
export const releaseNotesItemsLoaded = (state: State) =>
  state.releaseNotes.itemsLoaded;
export const releaseNotesItemsTree = (state: State) =>
  buildDocumentsTree(
    state.releaseNotes.items,
    null,
    (a, b) =>
      new Date(b.document.publishedDate).getTime() -
      new Date(a.document.publishedDate).getTime(),
  );
export const fetchReleaseNotesDocumentPending = (state: State) =>
  state.releaseNotes.fetchReleaseNotesDocumentPending;
